import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

function CustomAlert({
  alertMessage, handleAlertClose, alertSeverity = 'success', openAlert = false,
} : {alertMessage:string, openAlert:boolean, handleAlertClose:any, alertSeverity:any}) {
  return (
    <Snackbar
      open={openAlert}
      onClose={handleAlertClose}
      id="alert-box"
    >
      <Alert sx={{ width: '100%' }} severity={alertSeverity}>
        {alertMessage}
      </Alert>
    </Snackbar>
  );
}

export default CustomAlert;
